import { useEffect, useState } from "react";
import Select from 'react-select'
import DatePicker, { registerLocale } from "react-datepicker";
import { de } from 'date-fns/locale';
import Popup from "components/Popup/popup";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import styles from "./Popup.module.css";
import "react-datepicker/dist/react-datepicker.css";
import { BookingPopupProps } from "modules/booking-popup";
import { WorkTimeSlot, HolidaySlot } from "modules/calendar-worktime-holiday";
import { fetchHolidaySlots, fetchWorkSlots } from "services/workTime/calendar-service";
import { GoInfo } from "react-icons/go";
import { addDays, addWeeks, customSelectStyles, formatDate, getSlotsInDate } from "utils/bookingPopup";
import ErrorFailed from "components/errorFailed/errorFailed";
import { EmergencyContact, } from "modules/profile";
import { UnregesteredBookingValues } from "modules/booking";
import { computeAge } from "utils/profile";
import { FaArrowRight, FaRegTrashAlt } from "react-icons/fa";
import { MdAddToPhotos } from "react-icons/md";
import { setBookingUnregistered } from "services/booking/set-booking-unregistered";
import SuccessPopup from "components/successPopup/successPopup";

registerLocale('de', de);

export default function EmployUnregesteredBookingPopup({ isOpen, onClose, onChange }: BookingPopupProps) {
    const [unregesteredBookingFormValues, setUnregesteredBookingFormValues] = useState<UnregesteredBookingValues>({
        first_name: "",
        last_name: "",
        country: "",
        phone: "",
        zip: "",
        city: "",
        street: "",
        status: "",
        faculty: "",
        account_holder: "",
        iban: "",
        bic: "",

        kid_first_name: "",
        kid_last_name: "",
        emergencyContacts: [{ name: '', phone: '' }],
        birth_date: new Date,
        age: 0,
        allergy_medication: "",
        kid_note: "",

        recurrenceDates: [null, null, null, null],
        recurrenceStatuses: [false, false, false, false],
        bookingDate: new Date,
        block: [],
        recurrence: "",
        category: "",
        feedback: "",
        recurrence_date_0_status: "",
        recurrence_date_1_status: "",
        recurrence_date_2_status: "",
        recurrence_date_3_status: "",

    });

    const [workTimeSlots, setWorkTimeSlots] = useState<WorkTimeSlot[]>([]);
    const [holidaySlots, setHolidaySlots] = useState<HolidaySlot[]>([]);
    const [filteredBlocks, setFilteredBlocks] = useState<WorkTimeSlot[]>([]);
    const [isInfoOpen, setIsInfoOpen] = useState(false);
    const [emergencyContacts, setEmergencyContacts] = useState<EmergencyContact[]>(unregesteredBookingFormValues.emergencyContacts);
    const [ibanParts, setIbanParts] = useState(["", "", "", "", "", ""]);
    const [error, setError] = useState<string | null>(null);
    const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState(false);

    const handleInfoOpen = () => setIsInfoOpen(true);
    const handleInfoClose = () => setIsInfoOpen(false);

    const getSlotsData = async () => {
        try {
            const workData = await fetchWorkSlots();
            const holidayData = await fetchHolidaySlots();
            setWorkTimeSlots(workData);
            setHolidaySlots(holidayData);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        getSlotsData();
        setUnregesteredBookingFormValues(unregesteredBookingFormValues);
    }, []);

    const handleClose = () => {
        setUnregesteredBookingFormValues({
            first_name: "",
            last_name: "",
            country: "",
            phone: "",
            zip: "",
            city: "",
            street: "",
            status: "",
            faculty: "",
            account_holder: "",
            iban: "",
            bic: "",
            emergencyContacts: [{ name: '', phone: '' }],

            kid_first_name: "",
            kid_last_name: "",
            birth_date: new Date,
            allergy_medication: "",
            kid_note: "",
            age: 0,

            bookingDate: undefined,
            block: [],
            recurrence: "",
            category: "",
            feedback: "",
            recurrence_date_0_status: "",
            recurrence_date_1_status: "",
            recurrence_date_2_status: "",
            recurrence_date_3_status: "",
            recurrenceDates: [null, null, null, null],
            recurrenceStatuses: [false, false, false, false],
        });
        setEmergencyContacts(unregesteredBookingFormValues.emergencyContacts ?? []);
        setFilteredBlocks([]);
        setError(null);
        onClose();
    };
    const handleChangePopup = () => {
        handleClose();
        if (onChange) { onChange(); }
    }

    const handleIbanPartChange = (index: number, value: string) => {
        const updatedParts = [...ibanParts];
        updatedParts[index] = value.toUpperCase().replace(/[^A-Z0-9]/g, "");
        setIbanParts(updatedParts);
    };

    const addEmergencyContact = () => {
        const updatedContacts = [...emergencyContacts, { name: "", phone: "" }];
        setEmergencyContacts(updatedContacts);
        setUnregesteredBookingFormValues((prevValues) => ({
            ...prevValues,
            emergencyContacts: updatedContacts,
        }));
    };


    const handleEmergencyContactChange = (index: number, field: "name" | "phone", value: string) => {
        const updatedContacts = [...emergencyContacts];

        if (field === "phone") {
            const sanitizedValue = value.replace(/[^0-9+\-\s]/g, "");
            updatedContacts[index][field] = sanitizedValue;
        } else {
            updatedContacts[index][field] = value;
        }

        setEmergencyContacts(updatedContacts);
        setUnregesteredBookingFormValues((prevValues) => ({
            ...prevValues,
            emergencyContacts: updatedContacts,
        }));
    };



    const removeEmergencyContact = (index: number) => {
        if (emergencyContacts.length > 1) {
            const updatedContacts = emergencyContacts.filter((_, i) => i !== index);
            setEmergencyContacts(updatedContacts);
            setUnregesteredBookingFormValues((prevValues) => ({
                ...prevValues,
                emergencyContacts: updatedContacts,
            }));
        }
    };


    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;

        setUnregesteredBookingFormValues((prevValues) => {
            let sanitizedValue = value;

            if (name === 'phone') {
                sanitizedValue = value.replace(/[^0-9+\-\s]/g, "");
            }

            if (name === 'zip') {
                sanitizedValue = value.replace(/[^0-9]/g, "").slice(0, 5);;
            }

            const updatedValues = {
                ...prevValues,
                [name]: sanitizedValue,
                [name]: name === 'birth_date' && sanitizedValue ? new Date(sanitizedValue) : sanitizedValue,
                age: name === 'birth_date' && sanitizedValue ? computeAge(new Date(sanitizedValue)) : prevValues.age
            };

            if (name === 'recurrence' && sanitizedValue === 'serial' && prevValues.bookingDate) {
                const recurrenceDates: any[] = [];
                for (let i = 0; i < 4; i++) {
                    const nextDate = addWeeks(new Date(prevValues.bookingDate), i);
                    recurrenceDates.push(nextDate);
                }
                updatedValues.recurrenceDates = recurrenceDates;
                updatedValues.recurrenceStatuses = [true, true, true, true];
            } else if (name === 'recurrence' && sanitizedValue !== 'serial') {
                updatedValues.recurrenceDates = [null, null, null, null];
                updatedValues.recurrenceStatuses = [false, false, false, false];
            }

            return updatedValues;
        });
    };


    const handleRecurrenceChange = (index: number) => {
        setUnregesteredBookingFormValues((prevValues) => {
            const newRecurrenceStatuses = [...prevValues.recurrenceStatuses];
            newRecurrenceStatuses[index] = !newRecurrenceStatuses[index];
            return {
                ...prevValues,
                recurrenceStatuses: newRecurrenceStatuses,
            };
        });
    };

    const handleDateChange = (date: Date | null) => {
        if (date) {
            setUnregesteredBookingFormValues((prevValues) => {
                const updatedValues = { ...prevValues, bookingDate: date };
                if (updatedValues.recurrence === 'serial') {
                    const recurrenceDates: any[] = [];
                    for (let i = 0; i < 4; i++) {
                        const nextDate = addWeeks(new Date(date), i);
                        recurrenceDates.push(nextDate);
                    }
                    updatedValues.recurrenceDates = recurrenceDates;
                }

                return updatedValues;
            });

            setFilteredBlocks(getSlotsInDate(date, workTimeSlots, holidaySlots));
        }
    };
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const iban = ibanParts.join("");
        if (iban) {
            const regex = /^[A-Z]{2}\d{20}$/;
            if (!regex.test(iban)) {
                setError("Die IBAN-Format ist falsch, bitte korrigieren Sie es.");
            }
        }

        if (unregesteredBookingFormValues.recurrence === 'serial' && !unregesteredBookingFormValues.recurrenceStatuses.some((status: any) => status)) {
            setError('Bitte wählen Sie mindestens ein Wiederholungsdatum aus.');
            return;
        }

        const birthDate = new Date(unregesteredBookingFormValues.birth_date);
        const bookingDate = unregesteredBookingFormValues.bookingDate ? new Date(unregesteredBookingFormValues.bookingDate) : new Date();
        const ageDiff = bookingDate.getFullYear() - birthDate.getFullYear();
        const ageMonths = (bookingDate.getMonth() - birthDate.getMonth()) + ageDiff * 12;

        if (ageMonths < 6 || ageDiff > 11) {
            setError("Das Kind muss zwischen 6 Monaten und 11 Jahren alt sein.");
            return false;
        }

        try {
            const res = await setBookingUnregistered(unregesteredBookingFormValues);
            if (res.success) {
                setIsSuccessPopupOpen(true)

            } else {
                setError(res.message)
            }

        } catch (error) {
            console.error("Error submitting data:", error);
            setError("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.");
        }
    };


    if (!isOpen) { return null };
    return (
        <>
            <Popup
                title={"Neue Buchungsanfrage"}
                submitLabel={""}
                closeLabel={""}
                isWithButton={false}
                isOpen={true}
                onClose={handleClose}
            >
                <form onSubmit={handleSubmit}>
                    <section className={styles.section}>
                        <div className={styles.sectionTitle}>
                            <h3>Familienstammdaten</h3>
                        </div>
                        <div className={commonStyles.formGroupRow}>
                            <div className={commonStyles.formGroup}>
                                <label htmlFor="first_name">Vorname*</label>
                                <input
                                    type="text"
                                    id="first_name"
                                    name="first_name"
                                    value={unregesteredBookingFormValues.first_name}
                                    onChange={handleInputChange}
                                    required
                                />
                                <div className={commonStyles.goToOtherbooking} onClick={handleChangePopup}>
                                    <p> angemeldetes Kind  </p> <FaArrowRight />

                                </div>
                            </div>
                            <div className={commonStyles.formGroup}>
                                <label htmlFor="last_name">Nachname*</label>
                                <input
                                    type="text"
                                    id="last_name"
                                    name="last_name"
                                    value={unregesteredBookingFormValues.last_name}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                        </div>

                        <div className={commonStyles.formGroup}>
                            <label htmlFor="phone">Telefon</label>
                            <input
                                type="text"
                                id="phone"
                                name="phone"
                                value={unregesteredBookingFormValues.phone}
                                onChange={handleInputChange}

                            />
                        </div>
                        <div className={commonStyles.formGroup}>
                            <label htmlFor="country">Land</label>
                            <select
                                id="country"
                                name="country"
                                value={unregesteredBookingFormValues.country}
                                onChange={handleInputChange}

                            >
                                <option value="Deutschland">Deutschland</option>
                            </select>
                        </div>
                        <div className={commonStyles.formGroupRow}>
                            <div className={commonStyles.formGroup}>
                                <label htmlFor="zip">PLZ</label>
                                <input
                                    type="text"
                                    id="zip"
                                    name="zip"
                                    value={unregesteredBookingFormValues.zip}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className={commonStyles.formGroup}>
                                <label htmlFor="city">Stadt</label>
                                <input
                                    type="text"
                                    id="city"
                                    name="city"
                                    value={unregesteredBookingFormValues.city}
                                    onChange={handleInputChange}

                                />
                            </div>
                        </div>
                        <div className={commonStyles.formGroup}>
                            <label htmlFor="street">Straße & Haus Nr.</label>
                            <input
                                type="text"
                                id="street"
                                name="street"
                                value={unregesteredBookingFormValues.street}
                                onChange={handleInputChange}
                            />
                        </div>
                    </section>

                    <section className={styles.section}>
                        <div className={styles.sectionTitle}>
                            <h3>Status</h3>
                        </div>
                        <div className={commonStyles.formGroup}>
                            <label htmlFor="status">Status auswählen</label>
                            <select
                                id="status"
                                name="status"
                                value={unregesteredBookingFormValues.status}
                                onChange={handleInputChange}

                            >
                                <option value="" disabled>auswählen...</option>
                                <option value="student">Studierende Elternteil</option>
                                <option value="university_staff">Mitarbeiter:innen der Universität Siegen</option>
                                <option value="studierendenwerk_staff">Mitarbeiter:innen des Studierendenwerks Siegen</option>
                                <option value="professor">Professor:in</option>
                                <option value="other">Dritte</option>
                            </select>
                        </div>
                        <div className={commonStyles.formGroup}>
                            <label htmlFor="faculty">Fakultät auswählen</label>
                            <select
                                id="faculty"
                                name="faculty"
                                value={unregesteredBookingFormValues.faculty}
                                onChange={handleInputChange}

                            >
                                <option value="" disabled>auswählen...</option>
                                <option value="1">Fakultät I: Philosophie</option>
                                <option value="2">Fakultät II: Bildung/Architektur/Künste</option>
                                <option value="3">Fakultät III: Wirtschaftswissenschaften</option>
                                <option value="4">Fakultät IV: Naturwissenschaften</option>
                                <option value="5">Fakultät V: Lebenswissenschaft</option>
                                <option value="other">Keine Angabe</option>
                            </select>
                        </div>
                    </section>

                    <section className={styles.section}>
                        <div className={styles.sectionTitle}>
                            <h3>Kontodaten</h3>
                        </div>
                        <div className={commonStyles.formGroup}>
                            <label htmlFor="account_holder">Kontoinhaber</label>
                            <input
                                type="text"
                                id="account_holder"
                                name="account_holder"
                                value={unregesteredBookingFormValues.account_holder}
                                onChange={handleInputChange}
                            />
                        </div>

                        <div className={commonStyles.formGroup}>
                            <label>IBAN</label>
                            <div className={commonStyles.formGroupRow}>
                                <input
                                    type="text"
                                    maxLength={4}
                                    value={ibanParts[0]}
                                    onChange={(e) => handleIbanPartChange(0, e.target.value)}
                                />
                                <input
                                    type="text"
                                    maxLength={4}
                                    value={ibanParts[1]}
                                    onChange={(e) => handleIbanPartChange(1, e.target.value)}
                                />
                                <input
                                    type="text"
                                    maxLength={4}
                                    value={ibanParts[2]}
                                    onChange={(e) => handleIbanPartChange(2, e.target.value)}
                                />
                                <input
                                    type="text"
                                    maxLength={4}
                                    value={ibanParts[3]}
                                    onChange={(e) => handleIbanPartChange(3, e.target.value)}
                                />
                                <input
                                    type="text"
                                    maxLength={4}
                                    value={ibanParts[4]}
                                    onChange={(e) => handleIbanPartChange(4, e.target.value)}
                                />
                                <input
                                    type="text"
                                    maxLength={2}
                                    value={ibanParts[5]}
                                    onChange={(e) => handleIbanPartChange(5, e.target.value)}
                                />
                            </div>
                        </div>
                        <div className={commonStyles.formGroup}>
                            <label htmlFor="bic">BIC</label>
                            <input
                                type="text"
                                id="bic"
                                name="bic"
                                value={unregesteredBookingFormValues.bic}
                                onChange={handleInputChange}
                            />
                        </div>
                    </section>

                    <section className={styles.section}>
                        <div className={styles.sectionTitle}>
                            <div className={commonStyles.EmergencyContactSectionTitleRow}>
                                <h3>Notfallkontakte</h3> <MdAddToPhotos onClick={addEmergencyContact} />
                            </div>
                        </div>
                        {emergencyContacts.map((contact, index) => (
                            <div className={commonStyles.formGroupRow} key={index}>
                                <div className={commonStyles.formGroup}>
                                    <label htmlFor={`emergencyName${index}`}>Name*</label>
                                    <input
                                        type="text"
                                        id={`emergencyName${index}`}
                                        name={`emergencyName${index}`}
                                        value={contact.name}
                                        onChange={(e) => handleEmergencyContactChange(index, "name", e.target.value)}
                                        required
                                    />
                                </div>
                                <div className={commonStyles.formGroup}>
                                    <label htmlFor={`emergencyNumber${index}`}>Nummer*</label>
                                    <input
                                        type="text"
                                        id={`emergencyNumber${index}`}
                                        name={`emergencyNumber${index}`}
                                        value={contact.phone}
                                        onChange={(e) => handleEmergencyContactChange(index, "phone", e.target.value)}
                                        required
                                    />
                                </div>
                                {emergencyContacts.length > 1 && (
                                    <button
                                        type="button"
                                        className={styles.removeButton}
                                        onClick={() => removeEmergencyContact(index)}
                                    >
                                        <FaRegTrashAlt />
                                    </button>
                                )}
                            </div>
                        ))}

                    </section>

                    <section className={styles.section}>
                        <div className={styles.sectionTitle}>
                            <h3>KindsDaten</h3>
                        </div>
                        <div className={commonStyles.formGroupRow}>
                            <div className={commonStyles.formGroup}>
                                <label htmlFor="kid_first_name">Vorname*</label>
                                <input
                                    type="text"
                                    id="kid_first_name"
                                    name="kid_first_name"
                                    value={unregesteredBookingFormValues.kid_first_name}
                                    onChange={handleInputChange}

                                />
                                <div className={commonStyles.goToOtherbooking} onClick={handleChangePopup}>
                                    <p> angemeldetes Kind  </p> <FaArrowRight />

                                </div>
                            </div>
                            <div className={commonStyles.formGroup}>
                                <label htmlFor="kid_last_name">Nachname*</label>
                                <input
                                    type="text"
                                    id="kid_last_name"
                                    name="kid_last_name"
                                    value={unregesteredBookingFormValues.kid_last_name}
                                    onChange={handleInputChange}

                                />
                            </div>
                        </div>
                        <div className={commonStyles.formGroupRow}>
                            <div className={commonStyles.formGroup}>
                                <label htmlFor="birth_date">Geburtsdatum*</label>
                                <input type="date"
                                    id="birth_date"
                                    name="birth_date"
                                    value={
                                        unregesteredBookingFormValues.birth_date
                                            ? new Date(unregesteredBookingFormValues.birth_date).toISOString().split('T')[0]
                                            : ""
                                    }
                                    onChange={handleInputChange} />
                            </div>
                            <div className={commonStyles.formGroupOld}>
                                <p>{unregesteredBookingFormValues.age} Jahre</p>
                            </div>
                        </div>

                    </section>
                    <section className={styles.section}>
                        <div className={styles.sectionTitle}>
                            <h3>Allergien und Krankheiten</h3>
                        </div>
                        <div className={commonStyles.formGroup}>
                            <label htmlFor="allergy_medication">Allergien & Medikamente</label>

                            <textarea
                                id="allergy_medication"
                                name="allergy_medication"
                                value={unregesteredBookingFormValues.allergy_medication}
                                onChange={handleInputChange}
                                rows={3}
                            />
                        </div>
                    </section>
                    <section className={styles.section}>
                        <div className={styles.sectionTitle}>
                            <h3>Ergänzungen</h3>
                        </div>
                        <div className={commonStyles.formGroup}>
                            <label htmlFor="kid_note">Notiz</label>
                            <textarea
                                id="kid_note"
                                name="kid_note"
                                value={unregesteredBookingFormValues.kid_note}
                                onChange={handleInputChange}
                                rows={3}
                            />
                        </div>
                    </section>

                    <div className={styles.form}>
                        <div className={styles.sectionTitle}>
                            <h3>Buchungsdaten</h3>
                        </div>
                        <div className={commonStyles.formGroup}>
                            <label htmlFor="bookingDate">Datum*</label>
                            <DatePicker
                                selected={unregesteredBookingFormValues.bookingDate}
                                onChange={handleDateChange}
                                dateFormat="EEEE, dd. MMMM yyyy"
                                placeholderText="Wählen Sie ein Datum"
                                wrapperClassName={commonStyles.datepickerWrapperOverride}
                                id="bookingDate"
                                name="bookingDate"
                                locale="de"
                                required
                            />
                        </div>

                        <div className={commonStyles.formGroupRow}>
                            <div className={commonStyles.formGroup}>
                                <label htmlFor="block">Blöcke*</label>
                                <Select
                                    isMulti
                                    options={filteredBlocks.map((slot) => ({
                                        value: slot.id!.toString(),
                                        label: `${slot.start_time.substring(0, 5)} - ${slot.end_time.substring(0, 5)}${slot.number_of_places === 0 ? ' (ausgebucht)' : ''}`,
                                        isDisabled: slot.number_of_places === 0,
                                    }))}
                                    value={unregesteredBookingFormValues.block.map((blockId) => ({
                                        value: blockId,
                                        label: filteredBlocks.find((slot) => slot.id?.toString() === blockId)
                                            ? `${filteredBlocks.find((slot) => slot.id?.toString() === blockId)?.start_time.substring(0, 5)} - ${filteredBlocks.find((slot) => slot.id?.toString() === blockId)?.end_time.substring(0, 5)}`
                                            : '',
                                    }))}
                                    onChange={(selectedOptions) => {
                                        setUnregesteredBookingFormValues((prevValues) => ({
                                            ...prevValues,
                                            block: selectedOptions ? selectedOptions.map((option) => option.value) : [],
                                        }));
                                    }}
                                    placeholder="Wählen Sie Blöcke aus ..."
                                    styles={customSelectStyles}
                                />
                            </div>
                            <div className={commonStyles.formGroup}>
                                <label htmlFor="recurrence">
                                    Wiederholung* <GoInfo onClick={handleInfoOpen} />
                                </label>
                                <select
                                    id="recurrence"
                                    name="recurrence"
                                    value={unregesteredBookingFormValues.recurrence}
                                    onChange={(e) => {
                                        handleInputChange(e);

                                    }}
                                    required
                                >

                                    <option value="" disabled>
                                        auswählen ...
                                    </option>
                                    <option value="onetime">Einmalig</option>
                                    <option value="serial">Wöchentlich</option>
                                </select>
                            </div>
                        </div>
                        {unregesteredBookingFormValues.recurrence === "serial" && (
                            <div className={commonStyles.formGroup}>
                                <label>Enddatum: {formatDate(unregesteredBookingFormValues.recurrenceDates[2])}</label>


                                <div className={styles.chaeckBoxCountainer}>
                                    {Array.from({ length: 4 }).map((_, index) => (
                                        <div key={index} className={styles.recurrenceCheckbox}>
                                            <input
                                                type="checkbox"
                                                checked={!!unregesteredBookingFormValues.recurrenceStatuses[index]}
                                                onChange={() => handleRecurrenceChange(index)}
                                            />
                                            <span>
                                                {addDays(new Date(unregesteredBookingFormValues.bookingDate ? unregesteredBookingFormValues.bookingDate : ''), (index) * 7).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' })}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        <div className={commonStyles.formGroup}>
                            <label htmlFor="category">Kategorie*</label>
                            <select
                                id="category"
                                name="category"
                                value={unregesteredBookingFormValues.category}
                                onChange={handleInputChange}
                                required
                            >
                                <option value="" disabled>
                                    auswählen ...
                                </option>
                                <option value="care">Betreuung</option>
                                <option value="integration">Eingewöhnung</option>
                            </select>
                        </div>
                        <div className={commonStyles.formGroup}>
                            <h3>
                                <label htmlFor="feedback">Bemerkung</label>
                            </h3>
                            <textarea
                                id="feedback"
                                name="feedback"
                                value={unregesteredBookingFormValues.feedback}
                                onChange={handleInputChange}
                                className={styles.textarea}
                            />
                        </div>
                        {error && <ErrorFailed error={error} />}

                        <div className={commonStyles.formGroup}>
                            <p>
                                Nach dem Absenden überprüfen wir deine Anfrage und du erhältst eine Bestätigungsemail an die angegebene E-Mailadresse.
                            </p>
                        </div>
                    </div>

                    <div className={styles.popupButtonContainer}>
                        <button type="button" className={`${commonStyles.commonButton} ${commonStyles.backButton}`} onClick={handleClose}>
                            Abbrechen
                        </button>
                        <button type="submit" className={`${commonStyles.commonButton} ${commonStyles.submitButton}`} >
                            Buchung anfragen
                        </button>
                    </div>

                </form>
            </Popup>

            {isInfoOpen && (
                <Popup
                    title={"Information zur Wiederholung"}
                    submitLabel={""}
                    closeLabel={""}
                    isWithButton={false}
                    isOpen={true}
                    onClose={handleInfoClose}
                >
                    <p>
                        Wöchentliche Terminen gelten für ausgewählte Woche und die nächsten drei Wochen. Schließtage und bereits ausgebuchte Tage werden automatisch aus der Anfrage entfernt.
                    </p>

                </Popup>
            )}
            <SuccessPopup isPopupOpen={isSuccessPopupOpen} onClose={() => {
                handleClose();
                setIsSuccessPopupOpen(false);
            }} />
        </>
    );
}
